import type { SVGProps } from "react"

export const EmpoLogoWithBg = ({
	title = "Empo logo with background",
	...props
}: SVGProps<SVGSVGElement> & {
	title?: string
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		width="300"
		height="300"
		viewBox="0 0 300 300"
		{...props}
	>
		<g clipPath="url(#clip0_2014_11467)">
			<rect
				x="150"
				y="17"
				width="188"
				height="188"
				rx="35.25"
				transform="rotate(45 150 17)"
				fill="white"
			/>
			<rect
				x="150"
				y="50.2344"
				width="141"
				height="29.375"
				rx="14.6875"
				transform="rotate(45 150 50.2344)"
				fill="#84C99A"
			/>
			<rect
				x="71.0691"
				y="129.165"
				width="141"
				height="29.375"
				rx="14.6875"
				transform="rotate(45 71.0691 129.165)"
				fill="#84C99A"
			/>
			<rect
				x="93.9175"
				y="185.248"
				width="94"
				height="29.375"
				rx="14.6875"
				transform="rotate(-45 93.9175 185.248)"
				fill="#84C99A"
			/>
			<rect
				x="79.3777"
				y="120.856"
				width="58.75"
				height="29.375"
				rx="14.6875"
				transform="rotate(-45 79.3777 120.856)"
				fill="#84C99A"
			/>
			<rect
				x="158.309"
				y="199.787"
				width="58.75"
				height="29.375"
				rx="14.6875"
				transform="rotate(-45 158.309 199.787)"
				fill="#84C99A"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2014_11467">
				<rect
					width="188"
					height="188"
					fill="white"
					transform="translate(150 17) rotate(45)"
				/>
			</clipPath>
		</defs>
	</svg>
)
